import { Box, styled } from "@mui/material";

export const ListOfMigrationsWrapper = styled(Box)(() => {
	return {
		"& .title-box": {
			overflow: "hidden",
		},
		"& thead tr": {
			backgroundColor: "#842581",
			"& th": {
				color: "#FFFFFF",
				border: "1px solid #D9D9D9",
			},
		},
		"tbody tr": {
			boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
			"& td:last-child": {
				width: "30%",
				whiteSpace: "normal",
				border: "1px solid #D9D9D9",
			},
		},
	};
});
